import responsiveAssetConfig from './responsiveAssetConfig';

// this is the

export const breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
// prettier-ignore
export type ResponsiveImageBreakpoints = typeof breakpointKeys[number];

interface ResponsiveAsset {
  label: string;
  name: string;
}
const responsiveAsset = ({ label, name }: ResponsiveAsset) => {
  const breakpointAssets = breakpointKeys.reduce((memo, key) => {
    return [...memo, responsiveAssetConfig({ label: key, name: key })];
  }, [] as ReturnType<typeof responsiveAssetConfig>[]);
  return {
    label,
    name,
    description: 'Image URLs and metadata per breakpoint',
    type: 'object',
    fields: breakpointAssets
  };
};

export default responsiveAsset;
